import { render, staticRenderFns } from "./IconCaption.vue?vue&type=template&id=2c006f10&"
import script from "./IconCaption.vue?vue&type=script&lang=js&"
export * from "./IconCaption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c006f10')) {
      api.createRecord('2c006f10', component.options)
    } else {
      api.reload('2c006f10', component.options)
    }
    module.hot.accept("./IconCaption.vue?vue&type=template&id=2c006f10&", function () {
      api.rerender('2c006f10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconCaption.vue"
export default component.exports